import { Link } from 'react-router-dom';
import { useCaixa } from '../context/CaixaContext';

// Bloqueia páginas operacionais (PDV, Comandas, etc.) enquanto o caixa estiver fechado.
export default function CaixaGuard({ children }) {
  const { caixaAberto, loading } = useCaixa();

  if (loading) {
    return <div className="loading"><div className="spinner"></div>Verificando caixa...</div>;
  }

  if (!caixaAberto) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 48, maxWidth: 520, margin: '40px auto' }}>
        <div style={{ fontSize: '3rem', marginBottom: 12 }}>🔒</div>
        <h2 style={{ marginBottom: 8 }}>Caixa fechado</h2>
        <p style={{ color: 'var(--gray3)', marginBottom: 24 }}>
          Esta funcionalidade fica indisponível enquanto o caixa estiver fechado.
          Abra o caixa para iniciar as operações do dia.
        </p>
        <Link to="/admin/caixa" className="btn btn-success">💰 Ir para o Caixa</Link>
      </div>
    );
  }

  return children;
}
